import validate from "/home/runner/work/evaluation/evaluation/node_modules/.pnpm/nuxt@3.21.6_@types+node@22.19.19_@vue+compiler-sfc@3.5.35_eslint@9.39.4_less@4.6.4_sass-embed_37cefrshn5hmwgkrevl25vgqia/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/runner/work/evaluation/evaluation/middleware/auth.global.ts";
import code_45global from "/home/runner/work/evaluation/evaluation/middleware/code.global.ts";
import manifest_45route_45rule from "/home/runner/work/evaluation/evaluation/node_modules/.pnpm/nuxt@3.21.6_@types+node@22.19.19_@vue+compiler-sfc@3.5.35_eslint@9.39.4_less@4.6.4_sass-embed_37cefrshn5hmwgkrevl25vgqia/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  code_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}